import gql from 'graphql-tag';

export const GetDefaultSpaceQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query GetDefaultSpaceQuery($promotedSpaceKey: String) @experimental {
			experimentalPromotedSpaces(
				promotedSpacesLimit: 1
				otherSpacesLimit: 1
				promotedSpaceKey: $promotedSpaceKey
			) {
				nodes {
					id
				}
			}
		}
	`;
